// src/services/api.js
import { apiUrl } from '../config/api';

export async function apiRequest(endpoint, options = {}) {
  const {
    method = 'GET',
    body,
    headers: customHeaders = {},
  } = options;

  const headers = {
    'Content-Type': 'application/json',
    ...customHeaders,
  };

  const response = await fetch(apiUrl(endpoint), {
    method,
    headers,
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });

  let data = null;
  try {
    data = await response.json();
  } catch {}

  if (!response.ok) {
    const error = new Error(data?.message || `HTTP ${response.status}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
}
